<template>
  <div class='h100 width-100vw noPage'>
    <div class='h-toolbarBg'>
      <ejs-toolbar>
        <e-items>
          <e-item :prefixIcon='subscritionIcon' :tooltipText='$t("Alarm.alertSubscription")' :click='subscritionFunc'></e-item>
        </e-items>
      </ejs-toolbar>
    </div>
    <div class="h100-80 h-scroll">
    <ejs-grid ref='grid' height='100%' :dataSource='data' :contextMenuOpen='menuBeforeOpenFunc' :actionComplete='actionComplete'
              :editSettings='editOptions' :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' :allowExcelExport='true' :enableVirtualization='true' :enableColumnVirtualization='false'>
      <e-columns>
        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10'></e-column>
        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' minWidth='10' :disableHtmlEncode='false' :formatter='levelFormat' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='alarmTypeStr' :headerText='$t("Alarm.alarmType")' textAlign='Center' minWidth='10' :formatter='typeFormat' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neTypeStr' :headerText='$t("Alarm.neType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neName' :headerText='$t("Alarm.neName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentType' :headerText='$t("Alarm.equipmentType")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='equipmentName' :headerText='$t("Alarm.equipmentName")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearStateStr' :headerText='$t("Alarm.clearState")' textAlign='Center' minWidth='10' :formatter='clearFormat' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmStateStr' :headerText='$t("Alarm.confirmState")' textAlign='Center' minWidth='10' :formatter='confirmFormat' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearTimeFormat' :headerText='$t("Alarm.clearTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmTimeFormat' :headerText='$t("Alarm.confirmTime")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='clearUsrName' :headerText='$t("Alarm.clearUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='confirmUsrName' :headerText='$t("Alarm.confirmUser")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='messageNo' :isPrimaryKey='true' :headerText='$t("Alarm.remark")' :visible='false' textAlign='Center' minWidth='10'></e-column>
      </e-columns>
    </ejs-grid>
    </div>
  </div>
</template>

<script>
import { Edit, Reorder, Resize, ExcelExport, ContextMenu, GridPlugin, VirtualScroll, GridComponent } from '@syncfusion/ej2-vue-grids';
import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'CurrentAlarmSocket',
  data() {
    return {
      data: {},
      isOn: '0',
      websocketSetting: [
        { topic: '/user/#/CurrentAlarmServer', clientId: 'alarm', callback: this.websocketCallback }
      ],
      editOptions: { allowAdding: true, allowDeleting: true, newRowPosition: 'Top' },
      selectionOptions: { type: 'Multiple' },
      socketCurrentLength: 0,
      alarmSocketMaxCapcity: 20,
      alarmSocketInterval: 3000,
      currentFormalSize: 1000, // 标准单页展示1000条
      currentMaxSize: 1200, // 单页最大展示1200条
    };
  },
  props: {
    roleNe: {
      type: Array,
      default() {
        return [];
      }
    },
    roleNetMap: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    subscritionIcon() {
      return this.isOn === '1' ? 'icon hero-icon hero-icon-on' : 'icon hero-icon hero-icon-off';
    }
  },
  watch: {
    roleNe() {
      this.getAlarmListData();
    }
  },
  methods: {
    getAlarmListData() {
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarmPage', {
        conditions: '',
        keywords: '',
        roleNe: This.roleNe,
        page: {
          pageNo: 1,
          pageSize: this.currentFormalSize
        }
      }).then((response) => {
        if (response && response.status === 200) {
          if (response.data !== undefined && response.data.resultVal !== undefined) {
            this.socketCurrentLength = response.data.resultVal.result.length;
          };
          This.data = response.data.resultVal.result;
        }
      });
    },
    levelFormat(grids, data) {
      data.levelStr = this.$t(`Alarm.alarmLevel_${data.level}`);
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
    typeFormat(grid, data) {
      let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
      data.alarmTypeStr = str;
      return str;
    },
    clearFormat(grid, data) {
      let str = this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
      data.clearStateStr = str;
      return str;
    },
    confirmFormat(grid, data) {
      let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
      data.confirmStateStr = str;
      return str;
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      childList[childList.length - 1].style.display = this.getCheckedData(true).length > 1 ? 'none' : 'block';
    },
    actionComplete(args) {
      // if (args.action === 'add' || args.requestType === 'delete') { // 添加时会默认选中增加的行，现取消选择
      //   this.$refs.grid.selectRows([]);
      // }
      // this.disabled = true;
    },
    subscritionFunc() {
      // 点击告警订阅
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/modifyAutoPara').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = This.isOn === '1' ? '0' : '1';
          if (This.isOn === '1') {
            This.getAlarmListData();
          }
        }
      });
    },
    getSubscritionStatus() {
      // 刷新告警订阅状态 0:off 1:on
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryIsOn').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = `${response.data.resultVal.isOn}`;
          This.$emit('isOn', This.isOn);
        }
      });
    },
    alarmSocketCapcityFlag(alarmDataList) {
      console.log('alarmDataList', alarmDataList.length);
      let almCount = 0;
      for (let i = 0; i < alarmDataList.length; i++) {
        if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
          almCount ++;
          if (almCount === this.alarmSocketMaxCapcity) {
            break;
          }
        }
      }
      if (almCount === this.alarmSocketMaxCapcity) {
        return true;
      }
      return false;
    },
    websocketInit() {
      socketInstance.init(this.websocketSetting);
    },
    websocketCallback(msg) {
      const This = this;
      console.log('msg', msg);
      const data = JSON.parse(msg.body);
      if (data.type === 'currentAlarm') { // 新告警
        if (parseInt(this.isOn, 10) === 1) {
          const alarmDataList = JSON.parse(data.data);
          if (this.alarmSocketCapcityFlag(alarmDataList)) {
            this.getAlarmListData();
          } else {
            if (This.socketCurrentLength > This.currentMaxSize) { // 如果当前已经超过1500条 那么直接刷新页面回到一千条
              this.getAlarmListData();
            } else {
              for (let i = 0; i < alarmDataList.length; i++) {
                setTimeout(() => {
                  if ((this.roleNetMap[alarmDataList[i].nodeId] && this.roleNetMap[alarmDataList[i].nodeId] === 1)) {
                    This.$refs.grid.addRecord(alarmDataList[i]);
                    This.socketCurrentLength++;
                  }
                }, (parseInt(this.alarmSocketInterval / this.alarmSocketMaxCapcity)) * i);
              }
            }
          }
        }
      } else if (data.type === 'autoAlarm') {
        if (parseInt(This.isOn, 10) === 1) {
          const removeAlarmDataList = JSON.parse(data.data).removeData;
          const alarmDataList = JSON.parse(data.data).updateData;
          for (let i = 0; i < removeAlarmDataList.length; i++) {
            const index = This.data.findIndex(v => v.messageNo === parseInt(removeAlarmDataList[i], 10));
            if (index > -1) {
              const rowData = This.data[index];
              This.$refs.grid.deleteRecord('messageNo', rowData);
              This.socketCurrentLength--;
              for (let i = 0; i < alarmDataList.length; i++) {
                const index = This.data.findIndex(v => v.messageNo === alarmDataList[i].messageNo);
                if (index > -1) {
                  This.$refs.grid.updateRow(alarmDataList[i].messageNo, alarmDataList[i]);
                  break;
                }
              }
              break;
            }
          }
          for (let i = 0; i < alarmDataList.length; i++) {
            const index = this.data.findIndex(v => v.messageNo === alarmDataList[i].messageNo);
            if (index > -1) {
              this.$refs.grid.updateRow(alarmDataList[i].messageNo, alarmDataList[i]);
            }
          }
        }
      }
    },
  },
  provide: {
    grid: [Edit, Reorder, Resize, ExcelExport, ContextMenu, VirtualScroll]
  },
  mounted() {
    this.websocketInit();
    this.getSubscritionStatus();
  },
  beforeDestroy() {
    for (let i = 0; i < this.websocketSetting.length; i++) {
      socketInstance.stopReceiveTopicMsg(this.websocketSetting[i].clientId, this.websocketSetting[i].topic);
    }
  }
};
</script>

<style scoped>

</style>
